import { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../_metronic/partials'
import threeDots from '../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import searchIcon from '../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import { ComplianceMeetingTable } from './meeting-table'
import FilterIconFunnel from '../../../../media/resources/icons/filterIcon.svg'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getComplianceExportCsv } from '../core/_requests'
import { FilterMeeting } from './FilterMeeting'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import TagManager from 'react-gtm-module'
import { useAuth } from '../../auth'

export const ComplianceMeetingTableView = () => {
  const { formatMessage } = useIntl()
  const { companyId, currentUser } = useAuth()
  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const [sidebar, setSidebar] = useState(1)
  const [update, setUpdate] = useState(false)
  const { mode } = useThemeMode()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const location = useLocation()
  const tabRefs = useRef<Array<HTMLLIElement | null>>([]);
  const sidebarOptions = [
    { title: formatMessage({ id: 'Upcoming Meetings' }), id: 1, slug: formatMessage({ id: 'upcoming_meeting' }) },
    { title: formatMessage({ id: 'Board Meetings' }), id: 2, slug: formatMessage({ id: 'board_meeting' }) },
    { title: formatMessage({ id: 'Shareholders Meetings' }), id: 3, slug: formatMessage({ id: 'shareholders_meeting' }) },
    { title: formatMessage({ id: 'Other Meetings' }), id: 4, slug: formatMessage({ id: 'other_meeting' }) },
    { title: formatMessage({ id: 'Past Meetings' }), id: 5, slug: formatMessage({ id: 'past_meeting' }) },
  ]
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');
  const [sideBarTitle, setSideBarTitle] = useState(sidebarOptions[0].slug)
  const onTabChange = async (index: any) => {
    if (tabRefs.current[index]) {
      tabRefs?.current[index]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
    setSidebar(index + 1)
    setSideBarTitle(sidebarOptions[index].slug)
    navigate(`${location.pathname}?tab=${sidebarOptions[index].slug}`)
    setSearchInput('');
    setSearch('');
    if (meetingTypes === sidebarOptions[index].slug) {
      setFilter(false)
      setClear(false)
    }
    else {
      setUpdate(true)
      setFilter(false)
      setClear(true)
    }
  }
  const exportToCsv = async () => {
    try {
      const {
        data: { data: values, success, errors },
      } = await getComplianceExportCsv(sideBarTitle)
      if (success) {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.MeetingExportCsvSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email
            },
          },
        })
        toast.success(formatMessage({ id: 'Documents exported successfully' }))
        const url = window.URL.createObjectURL(new Blob([values]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'compliance_meeting.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } else {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.MeetingExportCsvFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: errors[0]
            },
          },
        })
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err: any) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.MeetingExportCsvFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err
          },
        },
      })
    }
  }
  const [filter, setFilter] = useState(false)
  const [clear, setClear] = useState(true)
  const [meetingList, setMeetingList] = useState<any[]>([])
  const [meetingTypes, setMeetingTypes] = useState('')
  const handleFilter = () => {
    setFilter(true)
  }
  useEffect(() => {
    if (clear) {
      onTabChange(sidebar - 1)
    }
  }, [clear])// eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (meetingTypes) {
      const data = sidebarOptions.find((data) => data.slug === meetingTypes)
      if (data) {
        setSidebar(data.id);
        setUpdate(true)
        setSideBarTitle(data.slug);
      }
    }
  }, [meetingTypes])// eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (tab) {
      const data = sidebarOptions.find((data) => data.slug === tab)
      if (data) {
        onTabChange(data.id - 1)
      }
    }
  }, [tab])// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearch(searchInput);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchInput]);// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className='d-md-flex mt-2 py-4 pt-2 justify-content-between w-100 align-items-center'>
        <div
          className={`mb-4 mb-md-0 sidebar-investor-db col-md-1 d-flex w-md-50 w-100 ${mode === 'dark' ? 'sc-tabs-line-dark' : 'sc-tabs-line'
            } `}
        >
          <div
            className=' d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs: any, index: number) => (
              <>
                <ul
                  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent text-muted fs-7 fw-semibold flex-nowrap mobile-tab-both my-md-0 mb-0 mt-0'
                  style={{ display: 'flex', flexWrap: 'nowrap', borderWidth: '0px' }}
                >
                  <div>
                    <li
                      key={index}
                      ref={(el) => (tabRefs.current[index] = el)}
                      className={
                        `nav-link text-active-primary fw-normal fs-6 py-3 ps-3 d-flex align-items-center cursor-pointer ` +
                        (sidebar === index + 1
                          ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                          : '')
                      }
                      onClick={() => onTabChange(index)}
                    >
                      {sideTabs.title}
                    </li>
                  </div>
                </ul>
              </>
            ))}
          </div>
        </div>

        <div
          className={`w-md-50 pb-1 ${mode === 'dark' ? 'sc-tabs-line-dark' : 'sc-tabs-line'
            } `}
        >
          {/* DROPDOWN BUTTON FOR MOBILE VIEW */}
          <div className='d-block d-md-none mb-3'>
            <button className='btn btn-primary justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-100' onClick={() => navigate(`../view/add-board-meeting${sidebar === 3 ? `?tab=shareholders-meeting` : sidebar === 4 ? '?tab=other-meeting' : '?tab=board-meeting'}`)}>{formatMessage({ id: 'New Meeting' })}</button>
          </div>
          <div className='d-flex justify-content-between justify-content-md-end gap-2 align-items-center w-100'>
            <div className={`${meetingTypes === sideBarTitle ? 'border-primary border-3' : ''} bg-white d-flex align-items-center rounded-2 height-36`}>
              <button
                className='text-muted btn btn-sm btn-flex fw-semibold font-size-12 py-2 rounded-2'
                title='Sort and Filter'
                type='button'
                onClick={handleFilter}
              >
                <img src={FilterIconFunnel} alt='' />
                <span className='d-none d-md-block ms-2'>
                  {formatMessage({ id: 'Filter' })}
                </span>
              </button>
            </div>

            {/* <form className=' align-items-center d-flex w-md-auto w-100'>
              <span className='svg-icon svg-icon-3 position-absolute ms-3'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className='mh-50px'
                >
                  <rect
                    opacity='0.5'
                    x='17.0365'
                    y='15.1223'
                    width='8.15546'
                    height='2'
                    rx='1'
                    transform='rotate(45 17.0365 15.1223)'
                    fill='currentColor'
                  ></rect>
                  <path
                    d='M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z'
                    fill='currentColor'
                  ></path>
                </svg>
              </span>
              <input
                type="text"
                className="bg-body form-control form-control-flush ps-10 height-36 rounded font-weight-400 text-clrA1 w-100"
                name="search"
                placeholder="Search Board Meeting"
                data-kt-search-element="input"
                value={searchInput} // Controlled input field
                onChange={(e) => setSearchInput(e.target.value)}
              />

            </form> */}
            <form className='align-items-center d-flex border rounded mb-md-0 mb-2 position-relative'>
              <span className='svg-icon svg-icon-3 position-absolute ms-2'>
                <img src={searchIcon} alt='Search icon' />
              </span>
              {/* <DebouncedInput
                value={searchInput}
                onChange={(e: any) => setSearchInput(e.target.value)}
                data-kt-search-element="input"
                className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-md-12 font-size-13 font-weight-400 height-36'
                placeholder="Search Board Meeting"
              /> */}
              <input
                type="text"
                className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-md-12 font-size-13 font-weight-400 height-36'
                name="search"
                placeholder="Search Board Meeting"
                data-kt-search-element="input"
                value={searchInput} // Controlled input field
                onChange={(e) => setSearchInput(e.target.value)}
              />
            </form>
            {/* DROPDOWN BUTTON FOR DESKTOP VIEW */}
            <div className='d-none d-md-block w-auto'>
              <button className='btn bg-primary custom-button-property text-white justify-content-center font-weight-400 font-size-13 height-36 d-flex align-items-center' onClick={() => navigate(`../view/add-board-meeting${sidebar === 3 ? `?tab=shareholders-meeting` : sidebar === 4 ? '?tab=other-meeting' : '?tab=board-meeting'}`)}>{formatMessage({ id: 'New Meeting' })}</button>
            </div>

            <div>
              <div
                className='cursor-pointer bg-white rounded-2 d-flex justify-content-center align-items-center width-36 height-36'
                onClick={() => setShowKebabMenu(!showKebabMenu)}
              >
                <img src={threeDots} alt='' />
              </div>
              {showKebabMenu && (
                <div
                  className='card shadow rounded top-4 cursor-pointer z-index-1 position-absolute w-150px'
                  style={{ top: '40px', right: 0 }}
                  onMouseLeave={() => setShowKebabMenu(false)}
                >
                  {/* <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100'>
                    <button
                      type='button'
                      className='m-0 border-0 bg-transparent dropdown_dark_text font-size-12'
                    >
                      {formatMessage({ id: 'Import CSV' })}
                    </button>
                  </div> */}
                  <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100'>
                    <button
                      type='button'
                      className='m-0 border-0 bg-transparent dropdown_dark_text font-size-12 hover-primary'
                      onClick={exportToCsv}
                    >
                      {formatMessage({ id: 'Export to CSV' })}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ComplianceMeetingTable sideBarTitle={sideBarTitle} search={search} meetingList={meetingList} filter={filter} setUpdate={setUpdate} update={update} clear={clear} />
      <FilterMeeting filter={filter} setFilter={setFilter} setMeetingList={setMeetingList} setMeetingTypes={setMeetingTypes} setClear={setClear} />
    </>
  )
}